import React from 'react'
import { Col, Row, Table } from 'react-bootstrap';
import { formatCurrency } from '../../util/Currency';
import { formatDate } from '../../util/Date';
import { getDonationStatus } from '../../util/Lookup';
import { evenRound } from '../../util/NumberUtils';
import { formatPhone } from 'util/Phone';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';


const DonationDetail = (props) => {
    const businessConfig = props.businessConfig;
    const donation = props.donation;
    const account = props.account;
    const accountTypeName = "DONATION";
    const logoImage = process.env.REACT_APP_BASE_API_URL + "/businesses/brandelements/logo"
    let totalTaxes = 0.0;
    let preTaxSubTotal = 0.0;
    return (
        <>
            <Row>
                <Col mb={7} lg={7} sm={7}>
                    <div>
                        <img src={logoImage} alt="..." height={businessConfig.logoHeight} width={businessConfig.logoWidth} />
                    </div>
                </Col>
                <Col mb={5} lg={5} sm={5} className="container d-flex justify-content-end">
                    <Table size="sm" striped={false} borderless={true} className="container d-flex justify-content-end"> 
                        <tbody>
                            <tr className='m-0 p-0'><td className='m-0 p-0'>{businessConfig.name}</td></tr>
                            {(businessConfig.type === 'NON_PROFIT') && <tr className='m-0 p-0'><td className='m-0 p-0'><b>Charity Number:</b> {businessConfig.charityNumber}</td></tr>}
                            <tr><td className='m-0 p-0'>{businessConfig.address}</td></tr>
                            <tr><td className='m-0 p-0'>{businessConfig.city}, {businessConfig.state}, {businessConfig.zip}</td></tr>
                            <tr><td className='m-0 p-0'><FontAwesomeIcon icon={faPhone} /> {formatPhone(businessConfig.phoneNumber)}</td></tr>
                            
                        </tbody>    
                    </Table>

                </Col>
            </Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>
                <Col>
                    <h6>Donated By</h6><br />
                    {account.firstName} {account.lastName}<br />
                    {account.address}<br />
                    {account.city}, {account.state}, {account.zip}<br />
                    <FontAwesomeIcon icon={faPhone} /> {formatPhone(account.mobilePhoneNumber)}<br/>
                    <FontAwesomeIcon icon={faEnvelope} /> {account.email}

                </Col>
                <Col>
                    <h6>Receipt Number</h6> {donation.receiptNumber}
                    <br /><br />
                    <h6>Date of Donation</h6> {formatDate(donation.donationDate)}
                    
                </Col>
                <Col>
                    <h6>Donation Number</h6> {donation.donationNumber}
                    <br /><br />
                    <h6>Account Number</h6>  {account.number}
                    <br /><br />
                    <h6>Account Type</h6> {accountTypeName}
                </Col>
                <Col>
                    <h6>Amount Donated</h6><h3>{formatCurrency(donation.amountDonated / 100, businessConfig.locale, businessConfig.currency)}</h3>
                    <h6>Donation Status</h6><h3>{getDonationStatus(donation.donationStatus)}</h3>
                </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>

            <Row>
                <Col>Line Item Description</Col>
                <Col>Rate</Col>
                <Col>Quantity</Col>
                <Col>Line Total</Col>
            </Row>
            <Row><Col>&nbsp;</Col></Row>
            {donation.lineItems.map((donationLineItem, idx) => {

                let lineItemAmount = donationLineItem.lineItemAmount;
                let lineItemQuantity = donationLineItem.quantity;
                let lineTotalTaxes = donationLineItem.taxable?parseFloat(lineItemAmount) * parseFloat(lineItemQuantity) * parseFloat(businessConfig.salesTaxRate):0;
                totalTaxes = parseFloat(totalTaxes) + parseFloat(lineTotalTaxes);
                let preTaxLineTotal = parseFloat(lineItemAmount) * parseFloat(lineItemQuantity);
                let lineItemTotal = preTaxLineTotal + lineTotalTaxes;
                preTaxSubTotal = parseFloat(preTaxSubTotal) + preTaxLineTotal;

                return (

                    <Row key={idx}>
                        <Col>
                            <h6>{donationLineItem.lineItemDescription}</h6>
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(lineItemAmount/100,2), businessConfig.locale, businessConfig.currency)}
                        </Col>
                        <Col>
                            {lineItemQuantity}
                        </Col>
                        <Col>
                            {formatCurrency(evenRound(lineItemTotal/100, 2), businessConfig.locale, businessConfig.currency)}
                        </Col>

                    </Row>
                )
            })}
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <h6>SubTotal</h6>
                </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>
                    {formatCurrency(evenRound(preTaxSubTotal/100,2), businessConfig.locale, businessConfig.currency)}
                </Col>
            </Row>
            <Row>
                &nbsp;
            </Row>
            <Row>
                <hr />
            </Row>

            <Row><Col>&nbsp;</Col></Row>
            <Row>
                <Col>
                    <h6>Total Amount Donated</h6>
                </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
                <Col>
                    {formatCurrency(donation.amountDonated / 100, businessConfig.locale, businessConfig.currency)}
                </Col>
            </Row>

        </>
    )
}

export default DonationDetail